import $ from 'jquery';
import 'parsleyjs';
import { toHash } from "@elements/hashing-sha256";
import {getPrefixedDataSet} from "@elements/data-set-utils"

const defaultSelectors = {
    base: '.js-form-tracking',
    input: '.js-form-tracking__input',
    select: '.js-form-tracking__select',
    checkbox: '.js-form-tracking__checkbox',
    btn: '.js-form-tracking__submit-btn',
};

const defaultOptions = {
    debug: false,
    formEvent: 'data-form-tracking-formEvent',
};

export function initInScope($scope, selectors = defaultSelectors, options = defaultOptions) {
    let $forms = $scope.find(selectors.base);
    $forms.each(function() {
        let $form = $(this);
        $form.parsley();
        //console.log('Form found:', $form);
        $form.on($form.attr(options.formEvent), function (e) {
            let isValid = $(this).parsley().validate();
           // console.log('Form submitted:', isValid);
            if (window.dataLayer && isValid) {
                window.dataLayer.push({
                    'event': $form.attr('data-form-tracking-event'),
                    'form_sent': $form.attr('data-form-tracking-form_sent'),
                    'leadsUserData': getLeadsUserData($form, selectors),
                });
            } else {
                console.error('dataLayer is not defined');
            }

            if (options.debug) {
                console.log('dataLayer: ', window.dataLayer);
                getLeadsUserData($form, selectors);
            }
        });
    });
};

// Helper function to convert UTF-8 string to byte representation for hashing
function utf8ToBytes(str) {
    const encoder = new TextEncoder();
    const bytes = encoder.encode(str);
    return Array.from(bytes).map(b => String.fromCharCode(b)).join('');
}
function normalizeGoogleEmail(email) {
    email = email.trim();
    // Lowercase
    email = email.toLowerCase();
    email = email.normalize('NFD');
    // Split the email into the local part and the domain part
    let [localPart, domainPart] = email.split("@");

    // Check if the domain is gmail.com or googlemail.com
    if (domainPart === "gmail.com" || domainPart === "googlemail.com") {
        // Remove all dots and plus from the local part (Plus + following characters )
        localPart =  localPart.replace(/\+.*$/, '').replace(/\./g, '');
    }
    //console.log('google reult', `${localPart}@${domainPart}`);
    return `${localPart}@${domainPart}`;
}

function normalizeMicrosoftEmail(email){
    // Whitespaces am Anfang/Ende entfernen
    email = email.trim();
    // Lowercase
    email = email.toLowerCase();
    // Akzente entfernen
    email = email.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    // Sämtliche Leerzeichen entfernen
    email = email.replace(/\s/g, '');
    // Split the email into the local part and the domain part
    let [localPart, domainPart] = email.split('@');
    //  Alle Punkte und Plus  vor "@" entfernen (das Plus + folgende Zeichen )
    localPart =  localPart.replace(/\+.*$/, '').replace(/\./g, '');
    //  "." muss nach "@" vorhanden sein (z.B. ".com")
    if (!domainPart || !domainPart.includes('.')) {
        return email; // Return as-is if invalid
    }
    //console.log('result', `${localPart}@${domainPart}`);
    return `${localPart}@${domainPart}`;
}

function getLeadsUserData($form, selectors) {
    let inputs = $form.find(selectors.input);
    let leadsUserData = { google: {}, microsoft: {}, facebook:{}, tiktok: {}};

    inputs.each(function () {
        let $input = $(this);
        let dataset = getPrefixedDataSet('form-tracking', $input);

        if (dataset.attribute && ($.type(dataset.attribute) === 'string')) {
            if (dataset.attribute.includes('sha256_')) {
                let value = $input.val().trim().toLowerCase().normalize('NFC');
                if (dataset.attribute === 'sha256_email_address') {
                    let normalizedGoogleValue = normalizeGoogleEmail(value);
                    let normalizedMicrosoftValue = normalizeMicrosoftEmail(value);
                    leadsUserData.google[dataset.attribute] = toHash(utf8ToBytes(normalizedGoogleValue));
                    leadsUserData.microsoft[dataset.attribute] = toHash(utf8ToBytes(normalizedMicrosoftValue));
                } else {
                    leadsUserData.google[dataset.attribute] = toHash(utf8ToBytes(value));
                }
                leadsUserData.tiktok[dataset.attribute] = toHash(utf8ToBytes(value));
                leadsUserData.facebook[dataset.attribute] = toHash(utf8ToBytes(value));
            } else {
                leadsUserData.google[dataset.attribute] = $input.val();
                leadsUserData.tiktok[dataset.attribute] = $input.val();
                leadsUserData.facebook[dataset.attribute] = $input.val();
            }
        } else if (dataset.attributeAddress && ($.type(dataset.attributeAddress) === 'string')) {
            if (!leadsUserData.google.address) {
                leadsUserData.google.address = {};
            }

            if (dataset.attributeAddress.includes('sha256_')) {
                let value = $input.val().trim().toLowerCase().normalize('NFC');
                if (dataset.attributeAddress === 'sha256_email_address') {
                    leadsUserData.google.address[dataset.attributeAddress] = toHash(utf8ToBytes(normalizeGoogleEmail(value)));
                } else {
                    leadsUserData.google.address[dataset.attributeAddress] = toHash(utf8ToBytes(value));
                }
                leadsUserData.tiktok[dataset.attributeAddress] = toHash(utf8ToBytes(value));
                leadsUserData.facebook[dataset.attributeAddress] = toHash(utf8ToBytes(value));
            } else {
                leadsUserData.google.address[dataset.attributeAddress] = $input.val();
                leadsUserData.tiktok[dataset.attributeAddress] = $input.val();
                leadsUserData.facebook[dataset.attributeAddress] = $input.val();
            }
        } else if (dataset.attributeCharacteristics && ($.type(dataset.attributeCharacteristics) === 'string')) {
            if (dataset.attributeCharacteristics.includes('sha256_')) {
                leadsUserData.facebook[dataset.attributeCharacteristics] = toHash(utf8ToBytes($input.val().trim().toLowerCase().normalize('NFC').charAt(0)));
            } else {
                leadsUserData.facebook[dataset.attributeCharacteristics] = $input.val();
            }
        }
    });


    console.log('leadsUserData', leadsUserData);
    return leadsUserData;
}